<h1 mat-dialog-title style="color: #D94E8F; font-weight: 900; font-size: 2rem;">Grand jeu à gratter : Happy Days des commerçants</h1>
<div mat-dialog-content>
  <div style="display: flex; flex-wrap: wrap;" [ngStyle]="{ 'flex-direction': (isHandset$ | async) ? 'column': 'row' }">
    <div style="flex: 3;">
      <div>
        <h3 style="font-weight: bold;">Participez aux Happy Days des commerçants <span style="color:  #D94E8F">à partir du 8 février !</span></h3>
        <p>L’association des commerçants et artisans de Levallois, l’ACAL organise à partir du 8 Février un grand jeu à gratter ouvert à toute personne majeure.<br />
        Pour participer, il vous suffit de vous rendre chez vos commerçants, artisans et prestataires de services, adhérents à l'association des commerçants et artisans de Levallois, l’ACAL à partir du 8 Février et d’y effectuer un achat.</p>

        <p style="font-weight: bold;">Le commerçant, artisan ou prestataires de services, vous remettra en échange un ticket à gratter.</p>

        <p>Le ticket indiquera immédiatement, après grattage de la zone si le joueur a gagné et le montant de la remise à déduire sur L’achat du joueur.</p>
        
        <h3 style="font-weight: bold;">3 gains possibles</h3>
        <p>5€ / 10€ / 20€</p>

        <p>L’association des commerçants et artisans de Levallois, l’ACAL <b style="color:  #D94E8F">offre à l’occasion de ce jeu à gratter 105 lots.</b></p>
        <br />
      </div>
      
      <div style="flex: 2; display: flex; justify-content: space-evenly; margin: 1rem 0;" [ngStyle]="{ 'flex-direction': (isHandset$ | async) ? 'column': 'row' }">
        <a mat-stroked-button href="assets/happy-days/commercants.pdf" target="_blank" style="margin: 1rem;"><mat-icon style="margin-right: 1rem; color: #D94E8F;">cloud_download</mat-icon> Liste des commerçants</a>
        <a mat-stroked-button href="assets/happy-days/reglement.pdf" target="_blank" style="margin: 1rem;"><mat-icon style="margin-right: 1rem; color: #D94E8F;">cloud_download</mat-icon> Règlement du jeu</a>
      </div>
    </div>
    <div style="flex: 1; padding: 10px;">
     <img src="assets/happy-days/affiche.jpg" style="max-width: 100%;" />
    </div>
  </div>
</div>